import MovbileMenuIcon from '@/legacy/components/ui/Icons/MovbileMenuIcon';
import { NotificationIcon } from '@/shared/ui/icons';
import ChevronDown from '@/legacy/components/ui/Icons/ChevronDown';
import { Button, DropdownMenu } from '@frekuent/orbit/components';
import NotificationsOffcanvas from '@/legacy/features/notifications/components/NotificationsOffCanvas';
import { ConfirmModal } from '@/legacy/components/ui/Modals';
import clsx from 'clsx';
import { useTopBar } from '../hooks/useTopBar';
import { useTopBarMenuItems } from '../hooks/useTopBarMenuItems';
import ProfileButtonContent from './ProfileButtonContent';

const TopBar = () => {
	const topBar = useTopBar();
	const {
		t,
		idUser,
		initials,
		companyName,
		unreadCount,
		isLogoutModalOpen,
		openOffcanvas,
		handleLogout,
		closeLogoutModal,
		profile,
		isLoading,
		isError,
	} = topBar;

	const { mobileMenuItems, desktopMenuItems } = useTopBarMenuItems(topBar);

	return (
		<>
			{/*
			 * `topbar.logout` and `topbar.confirm_logout_message` are duplicated in the
			 * profile namespace as `profile:logoutModal.title` and `.description`. The copy
			 * was deliberately copied rather than shared: the profile page renders its own
			 * logout confirmation, and editing this one should not silently change that
			 * screen. Update both, or neither.
			 */}
			<ConfirmModal
				isOpen={isLogoutModalOpen}
				onClose={closeLogoutModal}
				title={t('topbar.logout')}
				description={t('topbar.confirm_logout_message')}
				onSuccess={handleLogout}
				successMessage={t('logout_success')}
				errorMessage={t('topbar.logout_error')}
				onConfirm={handleLogout}
			/>

			<div className={clsx('flex items-center justify-end py-6')}>
				<div className='block lg:hidden'>
					<DropdownMenu
						items={mobileMenuItems}
						trigger={
							<Button
								variant='default'
								size='icon'
								aria-label={t('topbar.menu')}
							>
								<MovbileMenuIcon />
							</Button>
						}
					/>
				</div>

				<div className='lg:flex hidden gap-4'>
					<div className='relative'>
						<Button
							variant='default'
							onClick={() => openOffcanvas('notifications')}
							size='icon'
							aria-label={t('topbar.notifications')}
						>
							<NotificationIcon />
						</Button>
						{unreadCount > 0 && (
							<span className='absolute -top-1 -right-1 bg-error text-inverse text-xs w-5 h-5 flex items-center justify-center rounded-full'>
								{unreadCount}
							</span>
						)}
					</div>

					<DropdownMenu
						trigger={({ isOpen }) => (
							<Button
								variant='default'
								endAdornment={
									// TEMP: `!` until the Orbit 7.0.x patch lowers Button's icon-size rule with :where();
									// in 7.0.0 it beats any [&_svg] class from the container. Drop the `!` after bumping.
									<div
										className={`w-6 h-6 flex items-center justify-center text-secondary transition-transform [&_svg]:!h-2 [&_svg]:!w-[14px] ${isOpen ? 'rotate-180' : ''}`}
									>
										<ChevronDown />
									</div>
								}
								size='medium'
								className='px-2'
							>
								<ProfileButtonContent
									isLoading={isLoading}
									isError={isError}
									initials={initials}
									fullName={profile?.fullName}
									companyName={companyName}
								/>
							</Button>
						)}
						items={desktopMenuItems}
						className='w-48'
					/>
				</div>
			</div>

			<NotificationsOffcanvas userId={idUser ?? ''} />
		</>
	);
};

export default TopBar;
